<template>
  <div style="padding: 24px 24px 0">
    <TslBreadcrumb :titles="contentHeadQuery" :showTitle="false" />
    <div class="operate-table-wrapper">
      <div class="title">功能信息</div>
      <div class="operate-table">
        <div>
          <div>
            <span class="key">功能编码</span><span class="value"></span>{{ formState.identifier }}
          </div>
          <div>
            <span class="key">功能名称</span><span class="value"></span>{{ formState.name }}
          </div>
        </div>
        <div>
          <div>
            <span class="key">分类</span><span class="value"></span>{{ formState.categoryName }}
          </div>
          <div>
            <span class="key">标准</span><span class="value"></span>{{ formState.standard }}
          </div>
        </div>
        <div>
          <div>
            <span class="key">描述</span><span class="value"></span>{{ formState.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="property-table">
    <div class="title">历史版本</div>
    <a-table
      class="page-table"
      :dataSource="dataSource"
      :columns="columns"
      :pagination="false"
      :rowKey="(record) => record.id"
      :scroll="{ y: `calc(100vh - 560px)` }"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'element'">
          <a style="color: #5e66f2" @click.prevent="seeMeta(record)">查看</a>
        </template>
        <template v-if="column.key === 'version'">
          <div>{{ formatVersion(record.version) }}</div>
        </template>
      </template>
    </a-table>
  </div>
  <div ref="modal" class="modal-table-cover">
    <a-modal
      :width="640"
      :getContainer="() => $refs.modal"
      okText="关闭"
      destroyOnClose
      v-model:visible="showMetaModal"
      title="元件"
      @ok="
        () => {
          showMetaModal = false;
        }
      "
    >
      <ModalMeta :record="selectRecord" />
    </a-modal>
  </div>
</template>
<script>
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { Modal } from "ant-design-vue";
import TslBreadcrumb from "@/components/breadcrumb";
import { getFunctionHistoryListById } from "@/api/console/model/model-definition";
import ModalMeta from "./modals/meta/index.vue";
import { formatVersion } from "@/utils/tool.js";

export default defineComponent({
  name: "functionHistoryVision",
  components: {
    AModal: Modal,
    ModalMeta,
    TslBreadcrumb
  },
  setup() {
    //路由
    let router = useRouter();
    // 面包屑
    const contentHeadQuery = [
      { path: "/console/model/product", name: "产品管理" },
      { path: "/console/model/function", name: "功能管理" },
      { name: "详情" }
    ];
    const dataSource = ref([]);
    const selectRecord = ref({});
    const pagination = reactive({
      pageNum: 1,
      pageSize: 10,
      total: 10,
      showSizeChanger: true,
      pageSizeOptions: ["10", "20", "30", "50"]
    });
    let formState = reactive({});
    const columns = [
      {
        title: "序号",
        customRender: (record) => {
          return `${record.index + 1}`;
        },
        key: "sn"
      },
      {
        title: "版本",
        dataIndex: "version",
        key: "version"
      },
      {
        title: "发布时间",
        dataIndex: "updateTime",
        key: "updateTime"
        // sorter: (a, b) => {
        //   return a - b;
        // }
      },
      {
        title: "元件",
        dataIndex: "element",
        key: "element"
      }
    ];
    const backToIndex = () => {
      router.go(-1);
    };
    // 查看元件
    let showMetaModal = ref(false);
    const seeMeta = (record) => {
      selectRecord.value = record;
      selectRecord.value.functionVer = {
        id: record.id
      };
      showMetaModal.value = true;
    };
    const getTableData = async () => {
      let query = router.currentRoute.value.query;
      const res = await getFunctionHistoryListById(query.id);
      if (res.success) {
        dataSource.value = res.data ? res.data : [];
      }
    };
    const getCurrentData = () => {
      const str = sessionStorage.getItem("functionHistoryBase");
      let data = JSON.parse(str);
      formState.name = data.name;
      formState.standard = data.namespace === "standard" ? "是" : "否";
      formState.identifier = data.identifier;
      formState.description = data.description;
      formState.categoryName = data.categoryName;
    };
    onMounted(() => {
      getCurrentData();
      getTableData();
    });
    return {
      formatVersion,
      contentHeadQuery,
      backToIndex,
      dataSource,
      pagination,
      columns,
      formState,
      seeMeta,
      selectRecord,
      showMetaModal
    };
  }
});
</script>

<style lang="less" scoped>
:deep(.breadcrumb-component) {
  padding: 0;
  background: transparent;
}
.a-link {
  &:hover {
    color: #000;
  }
}
.property-table {
  margin: 24px;
  padding: 24px;
  background: @base-bg-default-color;
}
.operate-table-wrapper {
  margin-top: 8px;
  padding: 24px;
  background: #fff;
  border-radius: 4px;
}
.title {
  .font(18px,22px,22px,@weight:500);

  margin-bottom: 24px;
}
.operate-table {
  display: flex;
  background: #fff;
  > div {
    flex: 1;
    font-weight: 400;
    font-family: PingFangSC-Regular, PingFang SC;
    .key {
      display: inline-block;
      width: 80px;
      color: #86909c;
    }
    .value {
      color: @text-color-primary;
    }
    > div:nth-child(2) {
      margin-top: 16px;
    }
  }

  .form-content {
    word-break: break-all;
  }
}
</style>
